"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ClinicBranding/LogoPicker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


var _logoUpload = require('./logoUpload');
var _LogoCropModal = require('./LogoCropModal'); var _LogoCropModal2 = _interopRequireDefault(_LogoCropModal);

/* One logo picker: the current image, Upload (or Replace) and Remove. A
 * picked file is checked here, cropped (D-27: LogoCropModal exports the crop
 * as a PNG at its stored size), then uploaded at once; the server checks,
 * re-encodes and stores it, and the page saves its Path later. Cancel in the
 * crop step uploads nothing. A refusal is shown under the picker and the
 * current image stays. */



























const LogoPicker = ({
  orgKey, kind, inputLabel, imageAlt, url, shape, title, badge, roundPreview, description, placeholder,
  uploadLabel = 'Upload', onUploaded, onRemove, isDisabled, canUpload = true, className,
}) => {
  const inputRef = _react.useRef(null)
  const errorId = _react.useId.call(void 0, )
  const [error, setError] = _react.useState(null)
  const [summary, setSummary] = _react.useState(null)
  const [isUploading, setIsUploading] = _react.useState.call(void 0, false)
  // The picked file, while its crop step is open.
  const [cropFile, setCropFile] = _react.useState(null)
  // An upload still running when the picker goes (Cancel or Save remount
  // it) is aborted, and its answer, if it still comes, is dropped.
  const uploadRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => () => _optionalChain([uploadRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.abort, 'call', _3 => _3()]), [])

  const onPick = _react.useCallback.call(void 0, (event) => {
    const file = _optionalChain([event, 'access', _4 => _4.target, 'access', _5 => _5.files, 'optionalAccess', _6 => _6[0]])
    // The same file can be picked again after a refusal.
    event.target.value = ''
    if (!file) return
    const problem = _logoUpload.checkLogoFile.call(void 0, file)
    if (problem) {
      setError(problem)
      return
    }
    setError(null)
    setCropFile(file)
  }, [])

  const upload = _react.useCallback.call(void 0, (file) => {
    setCropFile(null)
    setIsUploading(true)
    _optionalChain([uploadRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.abort, 'call', _9 => _9()])
    const controller = new AbortController()
    uploadRef.current = controller
    Promise.all([_client2.default.uploadOrgLogo(orgKey, kind, file, controller.signal), _logoUpload.imageSize.call(void 0, file)])
      .then(([uploaded, size]) => {
        if (controller.signal.aborted) return
        setSummary(_logoUpload.fileSummary.call(void 0, file, size))
        onUploaded(uploaded, file)
      })
      .catch((e) => {
        if (controller.signal.aborted) return
        const message = _logoUpload.refusalMessage.call(void 0, e, "The image couldn't be uploaded. Try again.")
        // The server names "the icon" for every square logo.
        setError(kind === 'team' ? message.replace(/\bicon\b/i, 'team logo') : message)
      })
      .finally(() => { if (!controller.signal.aborted) setIsUploading(false) })
  }, [orgKey, kind, onUploaded])
  const cancelCrop = _react.useCallback.call(void 0, () => setCropFile(null), [])

  const openPicker = _react.useCallback.call(void 0, () => _optionalChain([inputRef, 'access', _10 => _10.current, 'optionalAccess', _11 => _11.click, 'call', _12 => _12()]), [])
  const remove = _react.useCallback.call(void 0, () => {
    setSummary(null)
    setError(null)
    onRemove()
  }, [onRemove])

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'logo-picker', `logo-picker--${shape}`, className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
      , _react2.default.createElement('div', { className: "logo-picker--grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
      , _react2.default.createElement('div', { className: "logo-picker--images", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
        , _react2.default.createElement('div', { className: "logo-picker--image", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
          ,  url
            ? _react2.default.createElement('img', { src: url, alt: imageAlt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}} )
            : _nullishCoalesce(placeholder, () => ( _react2.default.createElement('span', { className: "logo-picker--empty", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}} ))) 
        )
        ,  roundPreview && url && (
          _react2.default.createElement('div', { className: "logo-picker--round-preview", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}, _react2.default.createElement('img', { src: url, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}} ))
        )
      )
      , _react2.default.createElement('div', { className: "logo-picker--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
        ,  title && (
          _react2.default.createElement('div', { className: "logo-picker--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
            ,  title 
            ,  badge && _react2.default.createElement('span', { className: "logo-picker--badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}},  badge ) 
          )
        )
        ,  description && _react2.default.createElement('div', { className: "logo-picker--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}},  description ) 
        ,  summary && url && _react2.default.createElement('div', { className: "logo-picker--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}},  summary ) 
        ,  error && _react2.default.createElement('div', { id: errorId, className: "logo-picker--error", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}},  error ) 
      )
      , _react2.default.createElement('div', { className: "logo-picker--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
        ,  canUpload && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('input', {
              ref: inputRef,
          type: "file",
          accept: "image/png,image/jpeg",
          className: "logo-picker--input",
          'aria-label': inputLabel,
          'aria-describedby': error ? errorId : undefined,
          onChange: onPick,
          disabled: isDisabled || isUploading,
          tabIndex: -1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
            )
            , _react2.default.createElement('button', {
              type: "button",
              className: "logo-picker--upload",
              onClick: openPicker,
              disabled: isDisabled || isUploading, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}

              ,  isUploading ? 'Uploading…' : url ? 'Replace' : uploadLabel 
            )
          )
        )
        ,  url && (
          _react2.default.createElement('button', {
            type: "button",
            className: "logo-picker--remove",
            'aria-label': `Remove ${imageAlt.toLowerCase()}`,
            onClick: remove,
            disabled: isDisabled || isUploading, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
, "Remove"

          )
        )
      )
      )
      ,  cropFile && _react2.default.createElement(_LogoCropModal2.default, { file: cropFile, kind: kind, onCropped: upload, onCancel: cancelCrop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}} ) 
    )
  )
}

exports. default = LogoPicker
